import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

$(function() {
    const packageElements = $('.package');
    // if ($(window).width() < 992) {
        // const collapsableElements = $('.package');
        // packageElements.each(function(index) {
        //     const $this = $(this),
        //         collapsableEls = $this.find('.collapse');
        //     if (collapsableEls.length) {
        //         collapsableEls.removeClass('in');
        //     }
        // });
    // } else {
        if (packageElements.length === 3) {
            setTimeout(function() {
                setElementHeights(packageElements);
            }, 500);
        }

        $(window).resize(function() {
            setElementHeights(packageElements);
        });
    // }

    function setElementHeights(packageElements) {
        let largestPackageHeight = 0;
        const largestSectionHeights = [];

        // Set all heights to auto
        packageElements.each(function(index) {
            const $this = $(this),
                sections = $this.find('.section');

            $this.height('auto');

            sections.each(function(index) {
                const $this = $(this);
                $this.height('auto');
            });
        });

        if ($(window).width() < 992) return;

        // Find the heighest height
        packageElements.each(function(index) {
            const $this = $(this),
                height = $this.height(),
                sections = $this.find('.section');

            sections.each(function(index) {
                const $this = $(this),
                    height = $this.height();

                if (!largestSectionHeights[index] || height > largestSectionHeights[index]) {
                    largestSectionHeights[index] = height;
                }
            });
        });

        if (largestSectionHeights.length) {
            packageElements.each(function(index) {
                const $this = $(this),
                    sections = $this.find('.section');

                sections.each(function(index) {
                    const $this = $(this);
                    $this.height(largestSectionHeights[index]);
                });
            });
        }

        packageElements.each(function(index) {
            const $this = $(this),
                height = $this.height();

            if (height > largestPackageHeight) {
                largestPackageHeight = height;
            }
        });
        if (largestPackageHeight > 0) {
            packageElements.each(function(index) {
                const $this = $(this);
                $this.height(largestPackageHeight);
            });
        }
    }
});



// WEBPACK FOOTER //
// ./js/modules/multipleDealsPage.js